import React, { useEffect, useState } from "react"
import { enumUtil } from "../../../../utils/Enum"
import FormValidator from "../../../../utils/FormValidator"
import { GetZipCode, ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../utils/NotificationHandler"
import isNull from "../../../../utils/NullChecking"
import Loader from "../../../shared/Loader/Loader"
import Modal from 'react-bootstrap/Modal';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import States from "../../../../utils/Constants"
import NpiRegistry from '../../../General/NpiRegistry'
import handleNumericCheck from "../../../../utils/HandleNumericKeys"
import DeleteConfirmatiom from "../../../General/DeleteConfirmation"
import Audit from "../../../General/Audit"
import ReactInputMask from "react-input-mask"
import { useDispatch, useSelector } from "react-redux"
import ModalHeader from "../../Shared/ModalHeader"
import ModalFooter from "../../Shared/ModalFooter"
import SuperSearch from "../../../shared/SuperSearch/SuperSearch"
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList"
import FormatPhoneNumber from "../../../../utils/FormatPhoneNumber";
import DropdownValueHandler from "../../../shared/SuperSearch/DropdownValueHandler"
import DropdownCodeHandler from "../../../shared/SuperSearch/DropdownCodeHandler"
import UpdateReduxDropDowns from "../../../shared/UpdateReduxDropDowns"
import AddNewPOS from "../../Coding/POS/AddNewPOS"
import { SketchPicker } from "react-color"
import reactCSS from 'reactcss'
import { FindSecondChild } from "../../../../utils/FindMenuOption"

const AddNewLocation = (props) => {
    let IsEditAllowed = FindSecondChild('Setup', 'Account', 'Location')?.IsAdd
    let IsDeleteAllowed = FindSecondChild('Setup', 'Account', 'Location')?.IsDeleted
    let Location_Modal = {
        LocationName: "",
        ShortName: "",
        StartTime: '',
        EndTime: '',
        NPI: "",
        TaxID: "",
        TaxonomyCode: "",
        POSCode: "",
        AddressLine1: "",
        AddressLine2: "",
        City: "",
        State: "",
        ZipCode: "",
        ContactPhoneNumber: "",
        ContactPersonName: '',
        EmailAddress: "",
        FaxNumber: "",
        Website: "",
        CLIANumber: "",
        MemographyCertificationNum: "",
        PayToAddressLine1: "",
        PayToAddressLine2: "",
        PayToCity: "",
        PayToState: "",
        PayToZipCode: "",
        EnteredBy: "",
        ColorCode: ""
    }
    let valModal = {}
    let ValidationModal = {
        LocationNameVal: "",
        ShortNameVal: '',
        POSCodeVal: "",
        NPIVal: "",
        TaxonomyCodeVal: "",
        AddressLine2Val: "",
        CityVal: "",
        StateVal: "",
        ZipCodeVal: "",
        TaxIDLengthVal: "",
        ZipCodeLengthVal: "",
        ZipCodeDigitVal: '',
        PayToZipCodeLengthVal: "",
        FaxNumberLengthVal: "",
        LocationNPILengthVal: "",
        ContactNumberLenghtVal: "",
        EmailAddressVal: "",
        WebsiteVal: "",
        colorVal: '',
        StartTIme: '',
        EndTime: '',

    }
    const dispatch = useDispatch();

    let DropDowns = useSelector(state => state.GeneralDropDownsReducer)
    let ADC = DropDowns?.IsAdultDayCare
    let Homecare = DropDowns?.IsHomeCare

    const [POS, setPOS] = useState({ ID: '', Name: '' })
    const [locationID, setlocationID] = useState()
    const [practiceID, setPracticeID] = useState()
    const [LocationValidationModal, setLocationValidationModal] = useState(ValidationModal)
    const [LocationSaveUpdateModal, setLocationSaveUpdateModal] = useState({})
    const [mainLocationModal, setmainLocationModal] = useState(Location_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [NpiRegistryNumber, setNpiRegistryNumber] = useState('');
    const [isOpenRegistry, setIsOpenRegistry] = useState(false);
    const [del, setDel] = useState(false)
    const [isOpenAlert, setisOpenAlert] = useState(false);
    const [isOpenAudit, setisOpenAudit] = useState(false);
    const [statesValue, setStatesValue] = useState({ value: '', display: '' })
    const [PaytoStateValue, setPaytoStateValue] = useState({ value: '', display: '' })
    const API_URL = enumUtil.controller.General
    const { isOpenLocation, onClose, onDeleteLocation, npiModal, proceedHeader, onCloseProocedNpi, type } = { ...props }
    const [TaxonomyCode, setTaxonomyCode] = useState({ Code: '', MedicareSpecialityCode: '' })
    const [TaxonomyDD, setTaxonomyDD] = useState([])
    const [onLocationSaved, setOnLocationSaved] = useState(false)
    const [is, setIs] = useState(false);
    const [isOpenPOS, setOpenPSO] = useState(false);
    const [selectedClassification, setSelectedClassification] = useState('');
    const [displayColorPicker, setDisplayColorPicker] = useState(false);
    const [color, setColor] = useState("")

    useEffect(() => {
        // setPracticeID(PracticeID)
        if (props.LocationID != null) {
            setDel(true)
            setlocationID(props.LocationID)
        } else {
            if (!onLocationSaved) {
                setlocationID(0);
                setDel(false)
            } else {
                setDel(true)
            }
        }
        if (!isNull(locationID)) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "ID": locationID,
                "TableName": enumUtil.enumAPITableName.Location
            }).then((response) => {
                setIsLoading(false)
                setIs(true)
                response.State = DropdownValueHandler(States, response.State)
                response.PayToState = DropdownValueHandler(States, response.PayToState)
                response.POSCode = DropdownCodeHandler(DropDowns?.POS, response.POSCode)
                if (!isNull(response.ContactPhoneNumber)) {
                    response.ContactPhoneNumber = FormatPhoneNumber(response.ContactPhoneNumber)
                }
                setColor(response?.ColorCode === null ? response.ColorCode = "" : response.ColorCode)
                setmainLocationModal(response)
                setSelectedClassification(response.ClassificationSpecialization);
            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
        }
    }, [locationID])

    const handleLocationChange = (e, color) => {
        setIs(true)
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }
        let modal = { ...mainLocationModal };
        let saveModal = { ...LocationSaveUpdateModal }
        if (name === 'ContactPhoneNumber') {
            const formattedValue = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            modal[name] = !formattedValue[2] ? formattedValue[1] : '(' + formattedValue[1] + ') ' + formattedValue[2] + (formattedValue[3] ? '-' + formattedValue[3] : '');
        }
        else if (name === 'ZipCode') {
            GetZipCode(value)
                .then(data => {
                    setmainLocationModal(prevState => ({ ...prevState, ...data?.main }));
                    setLocationSaveUpdateModal(prevState => ({ ...prevState, ...data?.save }));
                })
                .catch(error => {
                });
            modal[name] = value;
        }
        else if (name === 'PayToZipCode') {
            GetZipCode(value)
                .then(data => {
                    modal.PayToState = data.main.State
                    modal.PayToCity = data.main.City
                    setmainLocationModal(prevState => ({ ...prevState, PayToCity: data.main.City, PayToState: data.main.State }));
                    saveModal.PayToState = data.save.State
                    saveModal.PayToCity = data.save.City
                })
                .catch(error => {
                });
            modal[name] = value;
        }
        else {
            modal[name] = value;
        }
        setmainLocationModal(modal)
        for (var property in Location_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setLocationSaveUpdateModal(saveModal)
        // if (name === 'NPI') 
        //     LocationValidation()
        // }
    }

    // const handleTimeChange = (e) => {
    //     const { name, value } = e.target; 
    //     let modal = { ...mainLocationModal };
    //     let saveModal = { ...LocationSaveUpdateModal };


    //     modal[name] = value;
    //     setmainLocationModal(modal);

    //     if (Location_Modal.hasOwnProperty(name)) {
    //       saveModal[name] = value;
    //     }

    //     setLocationSaveUpdateModal(saveModal);
    //   };
    const handleTimeChange = (e) => {
        const { name, value } = e.target;
        let modal = { ...mainLocationModal };
        let saveModal = { ...LocationSaveUpdateModal };

        modal[name] = value;

        const tempStartTime = name === "StartTime" ? value : modal.StartTime;
        const tempEndTime = name === "EndTime" ? value : modal.EndTime;

        if (tempStartTime && tempEndTime && tempStartTime > tempEndTime) {

            NotificationHandler('Start Time should be less than or equal to End Time.', enumUtil.enumtoaster.warning);
            modal["EndTime"] = "";
            saveModal["EndTime"] = "";

            setmainLocationModal(modal);
            setLocationSaveUpdateModal(saveModal);

            return;
        }

        setmainLocationModal(modal);

        if (Location_Modal.hasOwnProperty(name)) {
            saveModal[name] = value;
        }

        setLocationSaveUpdateModal(saveModal);
    };


    console.log(mainLocationModal, 'locationmodel');


    const handleLocationChangeDD = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainLocationModal };
        modal[name] = value
        setmainLocationModal(modal)
    }
    // validate Practice Modal 
    const LocationValidation = async () => {
        let PhoneNumber = '';
        let faxNumber = '';
        if (!isNull(mainLocationModal.ContactPhoneNumber)) {
            PhoneNumber = mainLocationModal.ContactPhoneNumber.replace(/[()-\s]/g, '');
        }
        if (!isNull(mainLocationModal.FaxNumber)) {
            faxNumber = mainLocationModal.FaxNumber.replace(/-/g, "");
        }
        let ValidationModal = {
            LocationNameVal: FormValidator(
                mainLocationModal.LocationName,
                enumUtil.enumValidationType.Required,
                'Location Name',
            ),
            ShortNameVal: FormValidator(
                mainLocationModal.ShortName,
                enumUtil.enumValidationType.Required,
                'Short Name',
            ),
            POSCodeVal: FormValidator(
                mainLocationModal.POSCode,
                enumUtil.enumValidationType.Required,
                'POS Code',
            ),
            NPIVal: FormValidator(
                mainLocationModal.NPI,
                enumUtil.enumValidationType.Length,
                'NPI',
                10
            ),
            EmailAddressVal: FormValidator(
                mainLocationModal.EmailAddress,
                enumUtil.enumValidationType.Email,
                'Email',
            ),
            // TaxonomyCodeVal: FormValidator(
            //     mainLocationModal.TaxonomyCode,
            //     enumUtil.enumValidationType.Required,
            //     'Taxonomy Code',
            // ),
            // AddressLine1Val: FormValidator(
            //     mainLocationModal.AddressLine1,
            //     enumUtil.enumValidationType.Required,
            //     'Address',
            // ),
            // AddressLine2Val: FormValidator(
            //     mainLocationModal.AddressLine2,
            //     enumUtil.enumValidationType.Required,
            //     'Address',
            // ),
            // CityVal: FormValidator(
            //     mainLocationModal.City,
            //     enumUtil.enumValidationType.Required,
            //     'City',
            // ),
            // StateVal: FormValidator(
            //     mainLocationModal.State,
            //     enumUtil.enumValidationType.Required,
            //     'State',
            // ),
            // ZipCodeVal: FormValidator(
            //     mainLocationModal.ZipCode,
            //     enumUtil.enumValidationType.Required,
            //     'Zip Code',
            // ),
            LocationNPILengthVal: FormValidator(
                mainLocationModal.NPI,
                enumUtil.enumValidationType.Length,
                'NPI',
                10
            ),
            ZipCodeLengthVal: FormValidator(
                mainLocationModal.ZipCode,
                enumUtil.enumValidationType.Lengths,
                'Zip Code',
                5, 9
            ),
            PayToZipCodeLengthVal: FormValidator(
                mainLocationModal.PayToZipCode,
                enumUtil.enumValidationType.Lengths,
                'Zip Code',
                5, 9
            ),
            ContactNumberLenghtVal: FormValidator(
                PhoneNumber,
                enumUtil.enumValidationType.Length,
                'Contact Number',
                10
            ),
            WebsiteVal: FormValidator(
                mainLocationModal.Website,
                enumUtil.enumValidationType.Website,
                'Website',
            ),
            FaxNumberLengthVal: FormValidator(
                faxNumber,
                enumUtil.enumValidationType.Length,
                'Fax Number',
                10
            ),
            TaxIDLengthVal: FormValidator(
                mainLocationModal.TaxID,
                enumUtil.enumValidationType.Length,
                'Tax ID',
                9
            ),
            ZipCodeDigitVal: FormValidator(
                mainLocationModal.ZipCode,
                enumUtil.enumValidationType.Digit,
                'Zip Code',
            ),
            
            // colorVal: FormValidator(
            //     mainLocationModal.ColorCode,
            //     enumUtil.enumValidationType.Required,
            //     'Color',
            // ),

             colorVal: ADC === 'true' || Homecare === 'true' ?  null : FormValidator(
                mainLocationModal.ColorCode,
                enumUtil.enumValidationType.Required,
                'Color',
            ),

            // StartTIme: FormValidator(
            //     mainLocationModal.StartTime,
            //     enumUtil.enumValidationType.Required,
            //     'Start Time',
            // ),
            // EndTime: FormValidator(
            //     mainLocationModal.EndTime,
            //     enumUtil.enumValidationType.Required,
            //     'End Time',
            // ),
            StartTime: ADC === 'true'
                ? FormValidator(
                    mainLocationModal.StartTime,
                    enumUtil.enumValidationType.Required,
                    'Start Time'
                )
                : null,

            EndTime: ADC === 'true'
                ? FormValidator(
                    mainLocationModal.EndTime,
                    enumUtil.enumValidationType.Required,
                    'End Time'
                )
                : null,


        }
        await setLocationValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const handleSaveLocation = async () => {
        // if (locationID == null) {
        //     setlocationID("");
        // }
        await LocationValidation()
        // console.log("valModal",[valModal], enumUtil.enumValidationType.NullCheck)
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            // LocationSaveUpdateModal['PracticeID'] = practiceID;
            if (!isNull(LocationSaveUpdateModal.FaxNumber)) {
                LocationSaveUpdateModal['FaxNumber'] = LocationSaveUpdateModal.FaxNumber.replace(/-/g, "");
            }
            if (!isNull(LocationSaveUpdateModal.ContactPhoneNumber)) {
                LocationSaveUpdateModal['ContactPhoneNumber'] = LocationSaveUpdateModal.ContactPhoneNumber.replace(/[()-\s]/g, "");
                LocationSaveUpdateModal.ContactPhoneNumber = LocationSaveUpdateModal.ContactPhoneNumber.slice(0, 10);
            }
            setLocationSaveUpdateModal(LocationSaveUpdateModal)
            let saveModal = {
                TableName: enumUtil.enumAPITableName.Location,
                ID: locationID,
                data: { ...LocationSaveUpdateModal },
                value: null
            }
            console.log(saveModal, 'saveModal');

            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        UpdateReduxDropDowns(locationID, DropDowns.Location, response.id, mainLocationModal.ShortName)

                        NotificationHandler(`Record Saved Successfully`, enumUtil.enumtoaster.success)
                        setlocationID(response.id)
                        setOnLocationSaved(true)
                        onDeleteLocation()
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    console.log('error', error);
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }
    const handleNpiRegistry = () => {
        if (mainLocationModal.NPI != undefined) {
            setNpiRegistryNumber(mainLocationModal.NPI)
        }
        setIsOpenRegistry(true);
        setIsLoading(false);
        onCloseProocedNpi();
    }
    const CloseRegistry = (data) => {
        console.log(data);
        setIs(true)
        if (data === NpiRegistryNumber) {
            setNpiRegistryNumber(data)
        }
        mainLocationModal.LocationName = !isNull(data.OrganizationName) ? data.OrganizationName : mainLocationModal.LocationName
        mainLocationModal.AddressLine1 = data.AddressLine1
        mainLocationModal.AddressLine2 = data.AddressLine2
        mainLocationModal.City = data.City
        mainLocationModal.State = DropdownValueHandler(States, data.State)
        // mainLocationModal.State = data.State
        mainLocationModal.ZipCode = data.ZipCode
        mainLocationModal.ContactPhoneNumber = data.ContactPhoneNumber
        mainLocationModal.PayToAddressLine1 = data.PayToAddressLine1
        mainLocationModal.PayToAddressLine2 = data.PayToAddressLine2
        mainLocationModal.PayToCity = data.PayToCity
        mainLocationModal.PayToState = DropdownValueHandler(States, data.PayToState)
        // mainLocationModal.PayToState = data.PayToState
        mainLocationModal.PayToZipCode = data.PayToZipCode
        mainLocationModal.NPI = data.NPI
        mainLocationModal.FaxNumber = data.FaxNumber
        mainLocationModal.ContactPersonName = !isNull(data.ContactPersonName) ? data.ContactPersonName : mainLocationModal.ContactPersonName
        mainLocationModal.TaxonomyCode = data.TaxonomyCode

        // setTaxonomyCode({ Code: data.TaxonomyCode, MedicareSpecialityCode: data.MedicareSpecialityCode })
        //SaveUpdateModal
        LocationSaveUpdateModal.LocationName = !isNull(data.OrganizationName) ? data.OrganizationName : mainLocationModal.LocationName
        LocationSaveUpdateModal.AddressLine1 = data.AddressLine1
        LocationSaveUpdateModal.AddressLine2 = data.AddressLine2
        LocationSaveUpdateModal.City = data.City
        LocationSaveUpdateModal.State = data.State
        LocationSaveUpdateModal.ZipCode = data.ZipCode
        LocationSaveUpdateModal.ContactPhoneNumber = data.ContactPhoneNumber
        LocationSaveUpdateModal.PayToAddressLine1 = data.PayToAddressLine1
        LocationSaveUpdateModal.PayToAddressLine2 = data.PayToAddressLine2
        LocationSaveUpdateModal.PayToCity = data.PayToCity
        LocationSaveUpdateModal.PayToState = data.PayToState
        LocationSaveUpdateModal.PayToZipCode = data.PayToZipCode
        LocationSaveUpdateModal.NPI = data.NPI
        LocationSaveUpdateModal.TaxonomyCode = data.TaxonomyCode
        LocationSaveUpdateModal.FaxNumber = data.FaxNumber
        const formattedPhoneNumber = !isNull(data.ContactPhoneNumber) ? FormatPhoneNumber(data.ContactPhoneNumber) : ''
        mainLocationModal.ContactPhoneNumber = formattedPhoneNumber;
        LocationSaveUpdateModal.ContactPhoneNumber = formattedPhoneNumber;

        setIsOpenRegistry(false)
    }
    const SetLocationName = () => {
        if (mainLocationModal.LocationName != null && mainLocationModal.LocationName != "") {
            return (
                <p className="heading sm">{mainLocationModal.LocationName}</p>
            )
        } else {
            return (
                <p className="heading sm">Add New Location</p>
            )
        }
    }
    const handleDeleteModal = () => { setisOpenAlert(true) }
    const onCloseDelete = () => { setisOpenAlert(false) }
    const handleAuditModal = () => { setisOpenAudit(true) }
    const onCloseAudit = () => { setisOpenAudit(false) }
    const onCloseNpi = () => { setIsOpenRegistry(false) }


    let DeletePopup = "";
    if (del) {
        DeletePopup = <button className='btn-icon-transparent' onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
    }
    let DeleteConfirmation = "";
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.Location} ID={locationID} onClose={onDeleteLocation} dropDown={DropDowns?.Location} />
    }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={locationID + ""} TableName={enumUtil.enumAPITableName.Location} />
    }
    let PopupScreen = "";
    if (isOpenRegistry) {
        PopupScreen = <NpiRegistry isOpenRegistry={isOpenRegistry} NpiNumber={NpiRegistryNumber} onClosee={CloseRegistry} onCloseNpi={onCloseNpi} LocationData={mainLocationModal} ClassName='npi-panel npi-open npi_detail_popup' />
    }
    const handleDropDownChange = (value, type) => {
        if (type === 'State') {
            setStatesValue(value)
            LocationSaveUpdateModal[type] = value.value + ""
        }
        if (type === 'PayToState') {
            setPaytoStateValue(value)
            LocationSaveUpdateModal[type] = value.value + ""
        }
        if (type === "POSCode") {
            setPOS(value)
            LocationSaveUpdateModal[type] = value.ID + ""
        }
        if (type === 'TaxonomyCode') {
            setTaxonomyCode(value)
            LocationSaveUpdateModal['TaxonomyCode'] = value.Code
            setTaxonomyDD([])
        }
        // if(type !== 'TaxonomyCode') LocationSaveUpdateModal[type] = value.ID + "";
    }
    const handleTaxonomySearch = (e) => {
        var searchvalue = e.target.value;
        if (e.target.value.length > 1) {
            ServerRequestProtected(API_URL + "/InstantSearch", 'post', {
                "TableName": enumUtil.enumAPITableName.Taxonomy,
                "SearchParam": searchvalue,
            }).then((response) => {
                setIsLoading(false)
                setTaxonomyDD(response)
            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
                setIsLoading(false)
            })
        }
    }
    const handleOnBlurVal = async () => {
        // await LocationValidation()
    }
    const styles = reactCSS({
        'default': {
            color: {
                background: color,
            },
            popover: {
                position: 'absolute',
                zIndex: '2',
            },
            cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
            },
        },
    });
    const handleSelectedData = (selectedData, name, type) => {

        let modal = { ...mainLocationModal };
        if (type === 'client' && !isNull(selectedData)) {
            console.log(selectedData, name, type);
            if (name === 'State') {
                modal[name] = selectedData.display
                LocationSaveUpdateModal[name] = selectedData.value;
            } else if (name === 'PayToState') {
                modal[name] = selectedData.display
                LocationSaveUpdateModal[name] = selectedData.value;
            }
            // else if (name === 'ShortName') {
            //     modal[name] = selectedData.display
            //     LocationSaveUpdateModal[name] = selectedData.value+"";
            // }
            else if (name === 'POSCode') {
                modal[name] = selectedData.display
                LocationSaveUpdateModal[name] = selectedData.code + "";
                LocationSaveUpdateModal['POSCodeID'] = selectedData.value + "";
            }

        } else if (type === 'server' && !isNull(selectedData)) {
            // if (name === 'POSCode') {
            //     LocationSaveUpdateModal[name] = selectedData.ID
            //     setPOS(selectedData.ID)

        } else {
            modal[name] = ''
            LocationSaveUpdateModal[name] = ''
        }
        setmainLocationModal(modal)

        return selectedData
    }

    ///////Super Search////////
    const getTaxonomyCodeSelected = (selectedData, name, type) => {
        if (!isNull(selectedData)) {
            if (type === 'client') {
                if (name === 'State') {
                }
            } else if (type === 'server') {
                if (name === 'TaxonomyCode') {
                    setmainLocationModal({ ...mainLocationModal, TaxonomyCode: selectedData.Code })
                    LocationSaveUpdateModal['TaxonomyCode'] = selectedData.Code
                    setSelectedClassification(selectedData.ClassificationSpecialization);
                }
            }
        } else {
            if (name === "TaxonomyCode") {
                setmainLocationModal({ ...mainLocationModal, TaxonomyCode: '' })
                LocationSaveUpdateModal['TaxonomyCode'] = ''
                setSelectedClassification('');
            }
        }
        return selectedData
    }
    // const contactFormat = (e) => {
    //     var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    //     e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    //     return x
    // }
    ///////////////
    const ClosePOS = () => {
        setOpenPSO(false)
    }
    const saveClosePOS = () => {
        setOpenPSO(false);
    }

    let PSOPopupScreen = "";
    if (isOpenPOS) {
        PSOPopupScreen = <AddNewPOS isOpenPOS={isOpenPOS} onClose={ClosePOS} onDeletePOS={saveClosePOS} />;
    }


    const PSOOpen = () => {
        setOpenPSO(true)
        // console.log(isOpenPOS,"popupOpen")
    }

    const handleClick = () => {
        setDisplayColorPicker(!displayColorPicker);
        console.log(displayColorPicker);

    };
    const handleClose = () => {
        setDisplayColorPicker(false);
    };

    const handleChange = (color) => {
        let name = "ColorCode";
        let value = color?.hex;
        let modal = { ...mainLocationModal };
        let saveModal = { ...LocationSaveUpdateModal };
        setColor(color.hex);
        modal[name] = value;
        setmainLocationModal(modal);
        for (var property in Location_Modal) {
            if (name === property) {
                saveModal[name] = value;
            }
        }
        setLocationSaveUpdateModal(saveModal);
    };
    const AddNewLocModalBody = () => {
        return (
            <div className="d-flex fa-layout h-100">
                <div className="form-col w-35">
                    <div className="pe-4">
                        <div className=" form-group input ">
                            <label htmlFor="">Location Name<span className='req'>*</span></label>
                            <div className={LocationValidationModal.LocationNameVal ? 'form-group input error' : 'form-group input'}>
                                <input type="text"
                                    maxLength={50}
                                    className='form-control'
                                    name="LocationName"
                                    id="LocationName"
                                    autoComplete="off"
                                    value={mainLocationModal.LocationName}
                                    onChange={handleLocationChange}
                                    onBlur={handleOnBlurVal}
                                />
                                {LocationValidationModal.LocationNameVal}
                            </div>
                        </div>
                        <div className="row rows-half m-0 mb-2 align-items-center">
                            <div className="col-md-6 ps-0">
                                <div className={LocationValidationModal.ShortNameVal ? 'form-group input error' : 'form-group input'}>
                                    <label htmlFor="DefaultUnits">Short Name<span className='req'>*</span></label>
                                    <input type="text"
                                        className='form-control'
                                        name="ShortName"
                                        id="ShortName"
                                        autoComplete="off"
                                        value={mainLocationModal.ShortName}
                                        // onKeyPress={handleNumericCheck}
                                        onChange={handleLocationChange}
                                    />
                                    {LocationValidationModal.ShortNameVal}
                                </div>
                            </div>

                            <div className="col-md-6 px-0">
                                <div className=" form-group input ">
                                    <div className="label-head d-flex justify-content-between mb-1  ">
                                        <label htmlFor="">POS Code<span className='req'>*</span></label>
                                        <div>
                                            <button class="btn-icon-circle btn-xs" onClick={PSOOpen}><i class="icon-plus-icon"></i></button>
                                        </div>
                                    </div>
                                    <div className={LocationValidationModal.POSCodeVal ? 'form-group input error' : 'form-group input'}>
                                        <SuperSearchList
                                            type="client"
                                            id='POSCode'
                                            name='POSCode'
                                            searchValue={mainLocationModal.POSCode}
                                            data={DropDowns.POS}
                                            onChange={handleLocationChangeDD}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                            inputError={LocationValidationModal.POSCodeVal}
                                        />
                                        {LocationValidationModal.POSCodeVal}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={LocationValidationModal.NPIVal ? 'input error' : LocationValidationModal.LocationNPILengthVal ? 'input error' : 'input'}>
                            <label htmlFor="">NPI</label>
                            <div className='field-icon'>
                                <input type="text"
                                    className='form-control'
                                    name="NPI"
                                    id="NPI"
                                    autoComplete="off"
                                    maxLength={10}
                                    value={mainLocationModal.NPI}
                                    onChange={handleLocationChange}
                                    onKeyPress={(event) => handleNumericCheck(event)}
                                />
                                <div className='last'>
                                    <div className="app_tooltip left" onClick={handleNpiRegistry}>
                                        <div className='NPI-R-circle'>R</div>
                                        <p class="tool_tip xsm_text text-light">NPI Registry</p>
                                    </div>
                                </div>
                            </div>
                            {LocationValidationModal.NPIVal ? LocationValidationModal.NPIVal : LocationValidationModal.NPILengthVal}
                        </div>
                        <div className={LocationValidationModal.TaxIDLengthVal ? 'form-group input error' : 'form-group input'}>
                            <label htmlFor="">Tax ID</label>
                            <input type="text"
                                className='form-control'
                                maxLength={9}
                                name="TaxID"
                                id="TaxID"
                                autoComplete="off"
                                value={mainLocationModal.TaxID}
                                onChange={handleLocationChange}
                                onKeyPress={(event) => handleNumericCheck(event)}
                            />
                            {LocationValidationModal.TaxIDLengthVal}
                        </div>
                        <div className='form-group input'>
                            <label htmlFor="">Taxonomy Code</label>
                            <SuperSearch
                                ApiLink={API_URL + "/InstantSearch"}
                                method="post"
                                postBody={{
                                    "TableName": enumUtil.enumAPITableName.Taxonomy,
                                    "SearchParam": mainLocationModal.TaxonomyCode,
                                }}
                                // tableHeight={400}
                                // tableWidth="400px"
                                id={'TaxonomyCode'}
                                getSelectedData={(value) => getTaxonomyCodeSelected(value, "TaxonomyCode", "server")}
                                onChange={(e) => setmainLocationModal({ ...mainLocationModal, TaxonomyCode: e.target.value })}
                                searchValue={mainLocationModal.TaxonomyCode}
                                tableData={[
                                    // { columName: 'ID', bindingValue: 'TaxonomyID', },
                                    { columName: 'Code', bindingValue: 'Code', },
                                    { columName: 'Medicare Speciality Code', bindingValue: 'MedicareSpecialityCode', },
                                ]}
                                disabled={false}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                            />
                        </div>
                        <div class="form-group input yellow-box">
                            <p class="mb-0">{selectedClassification}</p>
                        </div>
                        <div className='form-group input'>
                            <label htmlFor="">CLIA Number</label>
                            <input type="text"
                                maxLength={10}
                                className='form-control'
                                name="CLIANumber"
                                id="CLIANumber"
                                autoComplete="off"
                                value={mainLocationModal.CLIANumber}
                                onChange={handleLocationChange}
                            />
                        </div>
                        <div className='form-group input'>
                            <label htmlFor="">Mammography Number</label>
                            <input type="text"
                                maxLength={20}
                                className='form-control'
                                autoComplete="off"
                                name="MemographyCertificationNum"
                                id="MemographyCertificationNum"
                                value={mainLocationModal.MemographyCertificationNum}
                                onChange={handleLocationChange}
                                onKeyPress={(event) => handleNumericCheck(event)}
                            />
                        </div>
                        {ADC === 'true' ?
                            <>
                                <div className="row">
                                    {/* <div className={LocationValidationModal.StartTIme ? 'form-group input error' : 'form-group input'}> */}
                                    <div className="input col-md-6 pe-1">
                                        <div className={LocationValidationModal.StartTime ? 'form-group input error' : 'form-group input'}>
                                            <label className='text fs-12 ar-light-color'>Start Time</label>
                                            <input type="time" className='form-control fc-xs rounded-1'
                                                name="StartTime" id="StartTime" value={mainLocationModal?.StartTime}
                                                onChange={handleTimeChange}

                                            />
                                        </div>
                                        {LocationValidationModal.StartTime}
                                        {/* </div> */}
                                    </div>
                                    {/* <div className={LocationValidationModal.EndTime ? 'form-group input error' : 'form-group input'}> */}
                                    <div className="input col-md-6 ps-1">
                                        <div className={LocationValidationModal.EndTime ? 'form-group input error' : 'form-group input'}>
                                            <label className='text fs-12 ar-light-color'>End Time</label>
                                            <input type="time" className='form-control fc-xs rounded-1'
                                                name="EndTime" id="EndTime" value={mainLocationModal?.EndTime}
                                                onChange={handleTimeChange}
                                            />
                                        </div>
                                    </div>
                                    {LocationValidationModal.EndTime}
                                    {/* </div> */}
                                </div>
                            </>
                            : <></>}


                        {ADC === 'true' || Homecare === 'true' ? <></> :

                            <div className={LocationValidationModal.colorVal ? 'form-group input error' : 'form-group input'}>
                                <label for="lastName">Color Code <span className='req'>*</span></label>
                                <div>
                                    <div className="YM-color-picker" onClick={handleClick}>
                                        <div style={styles.color} />
                                    </div>
                                    {displayColorPicker ?
                                        <div className="location_clr" style={styles.popover}>
                                            <div style={styles.cover} onClick={handleClose} />
                                            <SketchPicker
                                                id='ColorCode'
                                                name='ColorCode'
                                                value={mainLocationModal.ColorCode}
                                                color={color}
                                                onChange={(color) => handleChange(color, mainLocationModal.ColorCode)}
                                            />
                                        </div> : null}
                                </div>
                                {LocationValidationModal.colorVal}
                            </div>
                        }

                    </div>
                </div>
                <div className="accordian-col w-65">
                    <div className="app-accordian">
                        <Accordion defaultExpanded>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                id="Location1-header"
                                aria-controls="Location1-content"
                            >
                                <p className="heading">Address Information</p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className='row row-gap-10 row-half'>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            {/* <div className='input'> */}
                                            <label htmlFor="">Address Line 1</label>
                                            <input type="text" className='form-control'
                                                autoComplete="off"
                                                name="AddressLine1"
                                                id="AddressLine1"
                                                maxLength={55}
                                                value={mainLocationModal.AddressLine1}
                                                onChange={handleLocationChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        {/* <div className={LocationValidationModal.AddressLine2Val ? 'input error' : 'input'}> */}
                                        <div className='input'>
                                            <label htmlFor="">Address Line 2</label>
                                            <input type="text" className='form-control'
                                                name="AddressLine2"
                                                id="AddressLine2"
                                                autoComplete="off"
                                                maxLength={55}
                                                value={mainLocationModal.AddressLine2}
                                                onChange={handleLocationChange}
                                            />
                                            {/* {LocationValidationModal.AddressLine2Val} */}
                                        </div>
                                    </div>
                                </div>
                                <div className='row row-gap-10 row-half mt-2'>
                                    <div className="col-md-6">
                                        {/* <div className={LocationValidationModal.CityVal ? 'input error' : 'input'}> */}
                                        <div className='input'>
                                            <label htmlFor="">City</label>
                                            <input type="text" className='form-control'
                                                name="City"
                                                id="City"
                                                autoComplete="off"
                                                maxLength={30}
                                                value={mainLocationModal.City}
                                                onChange={handleLocationChange}
                                            />
                                            {/* {LocationValidationModal.CityVal} */}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        {/* <div className={LocationValidationModal.StateVal ? 'input error' : 'input'}> */}
                                        <div className='input'>
                                            <label htmlFor="">State</label>
                                            <SuperSearchList
                                                type="client"
                                                id='State'
                                                name='State'
                                                searchValue={mainLocationModal.State}
                                                data={States}
                                                onChange={handleLocationChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                            // filterWith="startsWith"
                                            // tableHeight="200px"
                                            // tableWidth="100%"
                                            />
                                            {/* {LocationValidationModal.StateVal} */}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group input ">
                                            <label htmlFor="">Zip Code</label>
                                            <div className={LocationValidationModal.ZipCodeLengthVal || LocationValidationModal.ZipCodeDigitVal ? 'input error' : 'input'}>
                                                <input type="text" className='form-control'
                                                    name="ZipCode"
                                                    id="ZipCode"
                                                    autoComplete="off"
                                                    maxLength={9}
                                                    value={mainLocationModal.ZipCode}
                                                    onChange={handleLocationChange}
                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                />
                                                {LocationValidationModal.ZipCodeLengthVal || LocationValidationModal.ZipCodeDigitVal}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion defaultExpanded>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                id="Location2-header"
                                aria-controls="Location2-content"
                            >
                                <p className="heading">Contact Information</p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className='row row-gap-10 row-half'>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label htmlFor="">Name</label>
                                            <input type="text"
                                                className='form-control'
                                                maxLength={35}
                                                autoComplete="off"
                                                name="ContactPersonName"
                                                id="ContactPersonName"
                                                value={mainLocationModal.ContactPersonName}
                                                onChange={handleLocationChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group input ">
                                            <label htmlFor="">Contact Number</label>
                                            <div className={LocationValidationModal.ContactNumberLenghtVal ? 'form-group input error' : 'form-group input'}>
                                                <input
                                                    type="text"
                                                    className='form-control'
                                                    placeholder="(555) 555-5555"
                                                    name="ContactPhoneNumber"
                                                    id="ContactPhoneNumber"
                                                    autoComplete="off"
                                                    value={mainLocationModal.ContactPhoneNumber}
                                                    onChange={handleLocationChange}
                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                />
                                                {LocationValidationModal.ContactNumberLenghtVal}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group input ">
                                            <label htmlFor="">Email Address</label>
                                            <div className={LocationValidationModal.EmailAddressVal ? 'input error' : 'input'}>
                                                <input type="email"
                                                    maxLength={50}
                                                    className='form-control'
                                                    name="EmailAddress"
                                                    autoComplete="off"
                                                    id="EmailAddress"
                                                    value={mainLocationModal.EmailAddress}
                                                    onChange={handleLocationChange}
                                                />
                                                {LocationValidationModal.EmailAddressVal}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group input ">
                                            <label htmlFor="">Website</label>
                                            <div className={LocationValidationModal.WebsiteVal ? 'form-group input error' : 'form-group input'}>
                                                <input type="text"
                                                    className='form-control'
                                                    maxLength={200}
                                                    name="Website"
                                                    autoComplete="off"
                                                    id="WebsWebsite"
                                                    value={mainLocationModal.Website}
                                                    onChange={handleLocationChange}
                                                />
                                                {LocationValidationModal.WebsiteVal}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group input ">
                                            <label htmlFor="">Fax Number</label>
                                            <div className={LocationValidationModal.FaxNumberLengthVal ? 'form-group input error' : 'form-group input'}>
                                                <ReactInputMask type="text"
                                                    maskChar={0}
                                                    mask='999-999-9999'
                                                    className='form-control'
                                                    name="FaxNumber"
                                                    id="FaxNumber"
                                                    autoComplete="off"
                                                    value={mainLocationModal.FaxNumber}
                                                    onChange={handleLocationChange}
                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                />
                                                {LocationValidationModal.FaxNumberLengthVal}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                id="Location3-header"
                                aria-controls="Location3-content"
                            >
                                <p className="heading">Pay to Address Information</p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className='row row-gap-10 row-half'>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label htmlFor="">Address Line 1</label>
                                            <input type="text" className='form-control'
                                                name="PayToAddressLine1"
                                                id="PayToAddressLine1"
                                                autoComplete="off"
                                                maxLength={55}
                                                value={mainLocationModal.PayToAddressLine1}
                                                onChange={handleLocationChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label htmlFor="">Address Line 2</label>
                                            <input type="text" className='form-control'
                                                name="PayToAddressLine2"
                                                id="PayToAddressLine2"
                                                autoComplete="off"
                                                maxLength={55}
                                                value={mainLocationModal.PayToAddressLine2}
                                                onChange={handleLocationChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className='row row-gap-10 row-half mt-2'>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label htmlFor="">City</label>
                                            <input type="text" className='form-control'
                                                name="PayToCity"
                                                id="PayToCity"
                                                autoComplete="off"
                                                maxLength={30}
                                                value={mainLocationModal.PayToCity}
                                                onChange={handleLocationChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='input'>
                                            <label htmlFor="">State</label>
                                            <SuperSearchList
                                                type="client"
                                                id='PayToState'
                                                name='PayToState'
                                                searchValue={mainLocationModal.PayToState}
                                                data={States}
                                                onChange={handleLocationChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                            // filterWith="startsWith"
                                            // tableHeight="200px"
                                            // tableWidth="100%"
                                            />


                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group input ">
                                            <label htmlFor="">Zip Code</label>
                                            <div className={LocationValidationModal.PayToZipCodeLengthVal || LocationValidationModal.ZipCodeDigitVal ? 'input error' : 'input'}>
                                                <input type="text" className='form-control'
                                                    name="PayToZipCode"
                                                    id="PayToZipCode"
                                                    maxLength={9}
                                                    autoComplete="off"
                                                    value={mainLocationModal.PayToZipCode}
                                                    onChange={handleLocationChange}
                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                />
                                                {LocationValidationModal.PayToZipCodeLengthVal || LocationValidationModal.ZipCodeDigitVal}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <React.Fragment>
            {type && type === "Wizard" ?
                <>
                    {locationID === 0 ? <Modal show={npiModal} onHide={onCloseProocedNpi} backdrop="static" keyboard={false} dialogClassName="app-modal modal-lg proceed_npi_modal">
                        <Modal.Body>
                            {/* <SearchHeader masterListButton={proceedNPI} /> */}
                            <ModalHeader HeaderName={proceedHeader} DeletePopup={""} isClosed={onCloseProocedNpi} key={631} Name={'SwitchPractice'} />
                            <div className='container-fluid  br-clr'>
                                <div className="row">
                                    <div className={LocationValidationModal.NPIVal ? 'input error' : LocationValidationModal.LocationNPILengthVal ? 'input error' : 'input'}>
                                        <input
                                            className='form-control mb-1'
                                            name="NPI"
                                            id="NPI"
                                            autoFocus={true}
                                            autoComplete="off"
                                            maxLength={10}
                                            value={mainLocationModal.NPI}
                                            onChange={handleLocationChange}
                                            onKeyPress={(event) => handleNumericCheck(event)}
                                        />
                                    </div>
                                    <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                                        <button class="btn btn-orange btn-xs no-width rounded mb-0 proceed_btn" onClick={handleNpiRegistry} >Proceed <i className="icon-arrow-right"></i></button>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal> : null}
                    {DeleteConfirmation}
                    {PSOPopupScreen}
                    {AuditPopup}
                    {isLoading ? <Loader /> : null}
                    <div className="pb-15">
                        {AddNewLocModalBody()}
                    </div>
                    <ModalFooter isSaved={onLocationSaved ? onDeleteLocation : onClose} handleSave={handleSaveLocation} key={612} Name={'Location'} UpdatedDate={mainLocationModal.UpdatedDate} UpdatedBy={mainLocationModal.UpdatedBy} ID={locationID} IsEditAllowed={IsEditAllowed} />
                    {PopupScreen}
                </> :
                <>
                    {locationID === 0 ? <Modal show={npiModal} onHide={onCloseProocedNpi} backdrop="static" keyboard={false} dialogClassName="app-modal modal-lg proceed_npi_modal">
                        <Modal.Body>
                            {/* <SearchHeader masterListButton={proceedNPI} /> */}
                            <ModalHeader HeaderName={proceedHeader} DeletePopup={""} isClosed={onCloseProocedNpi} key={631} Name={'SwitchPractice'} />
                            <div className='container-fluid  br-clr'>
                                <div className="row">
                                    <div className={LocationValidationModal.NPIVal ? 'input error' : LocationValidationModal.LocationNPILengthVal ? 'input error' : 'input'}>
                                        <input
                                            className='form-control mb-1'
                                            name="NPI"
                                            id="NPI"
                                            autoFocus={true}
                                            autoComplete="off"
                                            maxLength={10}
                                            value={mainLocationModal.NPI}
                                            onChange={handleLocationChange}
                                            onKeyPress={(event) => handleNumericCheck(event)}
                                        />
                                    </div>
                                    <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                                        <button class="btn btn-orange btn-xs no-width rounded mb-0 proceed_btn" onClick={handleNpiRegistry} >Proceed <i className="icon-arrow-right"></i></button>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal> : null}
                    {DeleteConfirmation}
                    {PSOPopupScreen}
                    <Modal show={isOpenLocation} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg add_new_location hk-modal-v1">
                        {AuditPopup}
                        <Modal.Body>
                            <ModalHeader HeaderName={SetLocationName} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} DeletePopup={DeletePopup} handleDeleteModal={handleDeleteModal} isClosed={onLocationSaved ? onDeleteLocation : onClose} key={612} LocationName={'Location'} LocationID={locationID} IsDeleteAllowed={IsDeleteAllowed} />
                            {isLoading ? <Loader /> : null}
                            {AddNewLocModalBody()}
                            {PopupScreen}
                        </Modal.Body>
                        <ModalFooter isSaved={onLocationSaved ? onDeleteLocation : onClose} handleSave={handleSaveLocation} key={612} Name={'Location'} UpdatedDate={mainLocationModal.UpdatedDate} UpdatedBy={mainLocationModal.UpdatedBy} ID={locationID} IsEditAllowed={IsEditAllowed} />
                    </Modal>
                </>
            }
        </React.Fragment >
    )
}
export default AddNewLocation